<script src="fund-chart-legend.component.ts"></script>
<ng-container *ngIf="tooltipData && tooltipData.length > 0">
    <ng-container *ngFor="let offset of subchartOffsets; let index = index; let last = last">
        <div *ngIf="!last"
             class="chart-separator"
             [style]="{top: (offset - 1) + 'px'}">
        </div>
    </ng-container>
    <div class="chart-legend col-lg-8"
         [class]="{'chart-legend-annualized-data': showAnnualizedValue || showValue}"
         *ngFor="let chart of tooltipData; let index = index"
         [style]="{top: subchartOffsets[index] + 'px'}">
        <div *ngIf="showAnnualizedValue || showValue"
             class="chart-legend-item">
            <div class="chart-legend-item-name">
                <span class="chart-legend-item-title"></span>
            </div>
            <div class="chart-legend-item-date"></div>
            <div class="chart-legend-item-value">
                <div *ngIf="showValue" class="col-sm-6 cursor-pointer" (click)="setSort('value')"
                     [ngClass]="{'th-sort-asc': sortDirection == ASC, 'th-sort-desc': sortDirection == DESC}">
                    VAL
                    <div class="sort-mark"></div>
                </div>
                <div class="col-sm-6" *ngIf="showAnnualizedValue">
                    ANN
                </div>
            </div>
        </div>
        <div class="chart-legend-item"
             *ngFor="let series of chart">
            <div class="chart-legend-item-name">
            <span class="chart-legend-item-title chart-bullet">
                <span class="chart-bullet-point" [style]="{backgroundColor:  series.color }"></span>
                {{ series.longLabel }}
            </span>
            </div>
            <div class="chart-legend-item-date"
                 [textContent]="series.val1 !== '' ? series.val1 : ''">
            </div>
            <div class="chart-legend-item-value">
                <div class="col-sm-6" *ngIf="showValue" data-test-id="chart-legend-item-value"
                     [textContent]="series.val2 !== '' ? series.val2 : ''">
                </div>
                <div class="col-sm-6" *ngIf="showAnnualizedValue" data-test-id="chart-legend-item-value-annualized"
                     [textContent]="series.annualizedValue ? series.annualizedValue + '%' : '--'">
                </div>
            </div>
        </div>
    </div>
</ng-container>

